export default {
  saveSurvey: '/v3/question/survey/social/security'
}
